import React from 'react'
import PropTypes from 'prop-types'
import PressCardV2 from './PressCardV2'

function PressCardSet({ data }) {
  const { headline, backgroundColor, pressLinks } = data
  if (backgroundColor === 'Gray') {
    return (
      <section className="news">
        <div className="container__inner">
          <h2 className="news__heading heading-sub-bold heading-section">{headline}</h2>
          <div className="news__card-box">
            {pressLinks.map((el, index) => (
              /* eslint-disable react/no-array-index-key */
              <PressCardV2 data={el} key={index} />
            ))}
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="press-kit">
      <div className="container__inner">
        <h2 className="heading-sub-bold heading-section">{headline}</h2>
        <div className="press-kit__content-box">
          {pressLinks.map((el, index) => (
            /* eslint-disable react/no-array-index-key */
            <PressCardV2 data={{ isKit: true, ...el }} key={index} />
          ))}
        </div>
      </div>
    </section>
  )
}

PressCardSet.propTypes = {
  data: PropTypes.object.isRequired
}

export default PressCardSet
